import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withSignUp } from '../SignUpContext';
import { PageContainer } from '../../../components/page-container/PageContainer';
import { Page } from '../../../components/page/Page';
import { SignUpLayout } from '../user/SignUpLayout';

type Props = {
  email: string;
};

export class RawSignUpMailConfirmation extends React.Component<Props> {
  render() {
    return (
      <SignUpLayout>
        <PageContainer classNames="signup-car">
          <Page>
            <div className="signup-card__container center">
              <i className="material-icons icons__mail_outline signup-card__icon" />
              <div className="signup-card__title">
                <FormattedMessage id="signup/routes/mail/SignUpMailConfirmation.tsx/1" />
              </div>
              <p className="modal__subtitle">
                <FormattedMessage id="signup/routes/mail/SignUpMailConfirmation.tsx/2" />{' '}
                <b>{this.props.email}</b>{' '}
                <FormattedMessage id="signup/routes/mail/SignUpMailConfirmation.tsx/3" />
              </p>
            </div>
          </Page>
        </PageContainer>
      </SignUpLayout>
    );
  }
}

export const SignUpMailConfirmation = withSignUp(RawSignUpMailConfirmation);
